export enum PunchhApiServer {
  Punchh = 1,
  UsWestPunchh = 2,
  PosDQPunchh = 3,
}
